// extracted by css-extract-rspack-plugin
export default {"box":"contact-adder__box___eTvZU common__box___P1CnO"};